"use client";
import './assets/Button.css';const _ = "_button_1kh59_2", t = "_icon_1kh59_25", e = "_icon__left_1kh59_30", o = "_icon__right_1kh59_33", n = "_image_1kh59_36", c = "_text_block_1kh59_42", s = "_title_1kh59_49", a = "_text_1kh59_42", r = "__wide_1kh59_66", i = "_tiny_1kh59_69", h = "_icon__center_1kh59_82", k = "__center_text_1kh59_88", l = "_little_1kh59_100", d = "_small_1kh59_128", g = "_auth_type_1kh59_138", p = "_normal_1kh59_171", v = "_large_1kh59_207", m = "_orange_1kh59_251", w = "_violet_1kh59_262", y = "_none_1kh59_273", u = "_regular_1kh59_276", f = "_diamond_1kh59_276", b = "_outline_1kh59_287", x = "_overlay_1kh59_300", S = "_passive_1kh59_312", V = "_event_1kh59_319", j = "_white_1kh59_378", q = "_google_1kh59_378", z = "_apple_1kh59_378", A = "_passkey_1kh59_378", B = "_patreon_1kh59_378", C = "_twitter_1kh59_378", D = "_discord_1kh59_390", E = "_telegram_1kh59_401", F = "_reddit_1kh59_412", G = "_yandex_1kh59_423", H = "_facebook_1kh59_434", I = "_line_1kh59_445", J = "_whatsapp_1kh59_456", K = "_steam_1kh59_467", L = "_outlook_1kh59_478", M = "_yahoo_1kh59_489", N = "_mailru_1kh59_500", O = "_vk_1kh59_500", P = "_red_1kh59_412", Q = "_error_1kh59_511", R = "__error_1kh59_511", T = "__disabled_1kh59_522", U = "__loading_1kh59_526", W = "_rotation_1kh59_1", X = "_headShake_1kh59_1", Y = "_button_wrapper_1kh59_537", Z = "__active_1kh59_543", $ = "_icon_info_1kh59_556", __ = "_info_tag_1kh59_567", t_ = "_set_1kh59_579", e_ = "_setV2_1kh59_626", o_ = "_children_1_1kh59_651", n_ = "_active_0_1kh59_654", c_ = "_active_1_1kh59_657", s_ = "_active_2_1kh59_660", a_ = "_active_3_1kh59_663", r_ = "_active_4_1kh59_666", i_ = "_children_2_1kh59_669", h_ = "_children_3_1kh59_687", k_ = "_children_4_1kh59_705", l_ = "_children_5_1kh59_723", d_ = "_gray_1kh59_756", g_ = "_set_scrolled_1kh59_799", p_ = "_arrow_left_1kh59_802", v_ = "_arrow_right_1kh59_803", m_ = "_wrap_1kh59_814", w_ = "__masked_left_1kh59_826", y_ = "__masked_right_1kh59_829", u_ = "_inner_1kh59_835", f_ = {
  button: _,
  icon: t,
  icon__left: e,
  icon__right: o,
  image: n,
  text_block: c,
  title: s,
  text: a,
  _wide: r,
  tiny: i,
  icon__center: h,
  _center_text: k,
  little: l,
  small: d,
  auth_type: g,
  normal: p,
  large: v,
  orange: m,
  violet: w,
  none: y,
  regular: u,
  diamond: f,
  outline: b,
  overlay: x,
  passive: S,
  event: V,
  white: j,
  google: q,
  apple: z,
  passkey: A,
  patreon: B,
  twitter: C,
  discord: D,
  telegram: E,
  reddit: F,
  yandex: G,
  facebook: H,
  line: I,
  whatsapp: J,
  steam: K,
  outlook: L,
  yahoo: M,
  mailru: N,
  vk: O,
  red: P,
  error: Q,
  _error: R,
  _disabled: T,
  _loading: U,
  rotation: W,
  headShake: X,
  button_wrapper: Y,
  _active: Z,
  icon_info: $,
  info_tag: __,
  set: t_,
  setV2: e_,
  children_1: o_,
  active_0: n_,
  active_1: c_,
  active_2: s_,
  active_3: a_,
  active_4: r_,
  children_2: i_,
  children_3: h_,
  children_4: k_,
  children_5: l_,
  gray: d_,
  set_scrolled: g_,
  arrow_left: p_,
  arrow_right: v_,
  wrap: m_,
  _masked_left: w_,
  _masked_right: y_,
  inner: u_
};
export {
  f_ as s
};
